import React from "react";
import { Switch, Redirect } from "react-router-dom";

import { RouteWithLayout } from "./components";
import { Main as MainLayout, Minimal as MinimalLayout } from "./layouts";

import {
  Dashboard as DashboardView,
  SignOut as SignOutView,
  SignUp as SignUpView,
  SignIn as SignInView,
  NotFound as NotFoundView,
  Map as MapView,
} from "./views";

const Routes = () => {
  return (
    <Switch>
      <RouteWithLayout
        component={SignInView}
        exact
        layout={MinimalLayout}
        path="/sign-in"
        allowAnonymous={true}
      />
      <Redirect exact from="/" to="/dashboard" />
      <RouteWithLayout
        component={DashboardView}
        exact
        layout={MainLayout}
        path="/dashboard"
      />
      <RouteWithLayout
        component={MapView}
        exact
        layout={MainLayout}
        path="/map"
      />
      <RouteWithLayout
        component={SignUpView}
        exact
        layout={MinimalLayout}
        path="/logout"
      />

      <RouteWithLayout
        component={SignOutView}
        exact
        layout={MinimalLayout}
        path="/sign-out"
      />

      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MinimalLayout}
        path="/not-found"
      />
      <Redirect to="/not-found" />
    </Switch>
  )
};

export default Routes;
